var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLottery)?_c('broadcast'):_c('award-notice')
}
var staticRenderFns = []

export { render, staticRenderFns }